module.exports = "\r\n\r\n\r\n\r\n  <h1>Welcome to the Admin Panel</h1>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/dashboard-page/dashboard-page.html
// module id = ../../../../../src/app/admin-area/containers/dashboard-page/dashboard-page.html
// module chunks = main